class BaseSettings {

  constructor() {
    this._settings = null;
    return this;
  }

  factory(name, func) {
    this._settings = func();
    return this;
  }

  get(name) {
    return this._settings.get(name);
  }

  finish() {
    return this;
  }
}

var temp = new BaseSettings().factory('$ionicCoreSettings', function() {
  //"IONIC_SETTINGS_STRING_START";"IONIC_SETTINGS_STRING_END";
  var settings = {
    "app_id": "f4d30c1a",
    "api_key": "2f3f7231a46e75a08c363e47a7db26bcec15a6271af6809d",
    "gcm_key": process.env.GCM_SENDER_ID,
    "dev_push": false
  };
  return {
    get: function (setting) {
      if (settings[setting]) {
        return settings[setting];
      }
      return null;
    }
  };
})

.finish();

export class Settings {

  constructor() {
    this._locations = {
      'api': 'https://apps.ionic.io',
      'push': 'https://push.ionic.io',
      'analytics': 'https://analytics.ionic.io',
      'deploy': 'https://apps.ionic.io'
    };
    this._devLocations = this.get('dev_locations');
    if (!this._devLocations) { this._devLocations = {}; }
  }

  get(name) {
    return temp.get(name);
  }

  getURL(name) {
    if (this._devLocations[name]) {
      return this._devLocations[name];
    } else if (this._locations[name]) {
      return this._locations[name];
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/_libs/ionic-platform-web-client/core/settings.js